/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
	Button,
	createListCollection,
	Field,
	Portal,
	Select,
	Span,
	SpanProps,
} from '@welbe/design-system';
import { FiChevronDown } from 'react-icons/fi';

export type MedicalEnums =
	| 'Dr.'
	| 'Dra.'
	| 'Enf.'
	| 'Psic.'
	| 'Nut.'
	| 'Odont.'
	| 'Fisio.';

type TitleSelectorProps = {
	invalid?: boolean;
	value?: MedicalEnums;
	onChange: (value: MedicalEnums) => void;
};

const MEDICAL_ENUM: Record<MedicalEnums, string> = {
	'Dr.': 'Dr.',
	'Dra.': 'Dra.',
	'Enf.': 'Enf.',
	'Psic.': 'Psic.',
	'Nut.': 'Nut.',
	'Odont.': 'Odont.',
	'Fisio.': 'Fisio.',
};

const MedicalTitle = Object.entries(MEDICAL_ENUM).map(([value, label]) => ({
	value,
	label,
}));

export const DEFAULT_MEDICAL_TITLE: MedicalEnums = 'Dr.';

export const parseMedicalTitle = (value?: string | null): MedicalEnums | '' => {
	if (!value) return '';

	const isMedicalTitle = Object.keys(MEDICAL_ENUM).includes(value);

	return isMedicalTitle ? (value as MedicalEnums) : '';
};

export const TitleSelector = ({
	invalid,
	value,
	onChange,
}: TitleSelectorProps) => {
	const collection = createListCollection({
		items: MedicalTitle,
	});

	return (
		<Field.Root invalid={invalid} required>
			<Select.Root
				collection={collection}
				size="xs"
				width="85px"
				variant="outline"
				value={value ? [value] : []}
				invalid={invalid}
				onValueChange={(e: any) => {
					const [titleValue] = e.value;
					onChange(titleValue as MedicalEnums);
				}}
			>
				<Select.HiddenSelect />
				<Select.Control>
					{/* @ts-ignore */}
					<Select.Trigger px="0" border="none">
						<Button
							colorPalette="gray"
							px="0.25rem"
							variant="ghost"
							size="xs"
							w="full"
							maxW="72px"
							display="flex"
							border={invalid ? '1px solid red' : 'none'}
							justifyContent="space-between"
						>
							{value}
							<FiChevronDown />
						</Button>
					</Select.Trigger>
				</Select.Control>
				<Portal>
					<Select.Positioner>
						{/* @ts-ignore */}
						<Select.Content zIndex={4100}>
							{collection.items.map((framework: any) => (
								<Select.Item item={framework} key={framework.value}>
									{framework.label}
									<Select.ItemIndicator />
								</Select.Item>
							))}
						</Select.Content>
					</Select.Positioner>
				</Portal>
			</Select.Root>
		</Field.Root>
	);
};

type DoctorNameLabelProps = SpanProps & {
	title: string;
	name: string;
};

export const DoctorNameLabel = ({
	title,
	name,
	...rest
}: DoctorNameLabelProps) => {
	if (!title) return <Span {...rest}>{name}</Span>;

	return (
		<Span {...rest}>
			{title} {name}
		</Span>
	);
};
